import { useState } from 'react';

import PropTypes from 'prop-types';

import Button from '#globalComponents/Button/Button';
import Card from '#globalComponents/Card/Card';
import Select from '#globalComponents/Forms/Select';
import TextInput from '#globalComponents/Forms/TextInput';
import { useError } from '#globalContexts/ErrorContext';

import { useCreateBlacklistEntries } from '../../models/mutations';

const BlacklistEntryForm = ({ onCreated, onClose }) => {
	const { showError } = useError();
	const createMutation = useCreateBlacklistEntries();

	const [entryType, setEntryType] = useState('email');
	const [value, setValue] = useState('');
	const [reason, setReason] = useState('');

	const handleCreate = async () => {
		const trimmed = value.trim();
		if (!trimmed) return;
		try {
			await createMutation.mutateAsync({
				entries: [{ entryType, value: trimmed }],
				reason: reason.trim() || undefined,
			});
			onCreated();
		} catch (error) {
			showError({ error, title: 'Eintrag konnte nicht hinzugefügt werden' });
		}
	};

	const handleKeyDown = (e) => {
		if (e.key === 'Enter') handleCreate();
		if (e.key === 'Escape') onClose();
	};

	return (
		<Card className="mb-3.5 border-primary-200">
			<h3 className="text-sm font-semibold text-text mb-3">Eintrag hinzufügen</h3>
			<div className="flex flex-wrap gap-2">
				<Select value={entryType} onChange={(e) => setEntryType(e.target.value)} className="w-32 shrink-0">
					<option value="email">E-Mail</option>
					<option value="domain">Domain</option>
				</Select>
				<TextInput
					value={value}
					onChange={(e) => setValue(e.target.value)}
					onKeyDown={handleKeyDown}
					placeholder={entryType === 'email' ? 'name@firma.de' : 'firma.de'}
					className="flex-1 min-w-[200px]"
					autoFocus
					maxLength={255}
				/>
				<TextInput
					value={reason}
					onChange={(e) => setReason(e.target.value)}
					onKeyDown={handleKeyDown}
					placeholder="Grund (optional)"
					className="flex-1 min-w-[160px]"
					maxLength={500}
				/>
				<Button
					variant="solid"
					size="sm"
					onClick={handleCreate}
					disabled={!value.trim() || createMutation.isPending}
				>
					{createMutation.isPending ? 'Speichere ...' : 'Hinzufügen'}
				</Button>
				<Button variant="outline" size="sm" onClick={onClose}>
					Abbrechen
				</Button>
			</div>
		</Card>
	);
};

BlacklistEntryForm.propTypes = {
	onCreated: PropTypes.func.isRequired,
	onClose: PropTypes.func.isRequired,
};

export default BlacklistEntryForm;
